/**
 * Utility to help deduplicate an array of primitive data types
 */
export default arr => [...new Set(arr)];
